module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "css-control css-control-primary css-checkbox"
  }, [_c('input', {
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.currentValue
    },
    on: {
      "change": _vm.save
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f69f6c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/ExternallyAvailableEditable.vue
// module id = 763
// module chunks = 1